
import { Component, Prop, Vue } from 'vue-property-decorator';
import ButtonBlock from '@/components/content/blocks/ButtonBlock.vue';
import DashboardCallToActionBlock from '@/components/content/blocks/DashboardCallToActionBlock.vue';
import DashboardTextBlock from '@/components/content/blocks/DashboardTextBlock.vue';
import DoubleColumnsTextBlock from '@/components/content/blocks/DoubleColumnsTextBlock.vue';
import DownloadListBlock from '@/components/content/blocks/DownloadListBlock.vue';
import EatThisDownloadBlock from '@/components/content/blocks/EatThisDownloadBlock.vue';
import ImageCarouselBlock from '@/components/content/blocks/ImageCarouselBlock.vue';
import IntroBlock from '@/components/content/blocks/IntroBlock.vue';
import NewsCardBlock from '@/components/content/blocks/NewsCardBlock.vue';
import PagesBlock from '@/components/content/blocks/PagesBlock.vue';
import TextimageBlock from '@/components/content/blocks/TextimageBlock.vue';
import YoutubeBlock from '@/components/content/blocks/YoutubeBlock.vue';
import VideoBlock from '@/components/content/blocks/VideoBlock.vue';
import ContactBlock from './blocks/ContactBlock.vue';

@Component({
  components: {
    buttonBlock: ButtonBlock,
    contactBlock: ContactBlock,
    dashboardcalltoactionBlock: DashboardCallToActionBlock,
    dashboardtextBlock: DashboardTextBlock,
    double_columns_textBlock: DoubleColumnsTextBlock,
    downloadlistBlock: DownloadListBlock,
    eatthisdownloadBlock: EatThisDownloadBlock,
    imagecarouselBlock: ImageCarouselBlock,
    introBlock: IntroBlock,
    newsBlock: NewsCardBlock,
    pagesblock: PagesBlock,
    textimageBlock: TextimageBlock,
    youtubeBlock: YoutubeBlock,
    videoBlock: VideoBlock,
  },
})
export default class ContentBlocks extends Vue {
  @Prop(Array)
  blocks!: any[];

  @Prop(Array)
  pages!: any[];

  @Prop({ type: Boolean, default: false })
  hasBackgroundColor!: boolean;

  @Prop({ type: Boolean, default: true })
  hasLayoutContent!: boolean;

  @Prop({ type: Boolean, default: false })
  multinational!: boolean;

  @Prop({ type: Boolean, default: false })
  noTopMargin!: boolean;
}
